import React from 'react'
import { styled } from '@mui/material/styles'
import palette from 'core-system/Themes/palette'
import { Button, ButtonProps, CircularProgress } from '@mui/material'

const PrimaryButtonContainer = styled(Button)<{ active?: boolean }>(
  ({ active }) => ({
    borderRadius: '0.375rem',
    padding: '0.625rem 1rem',
    fontFamily: 'PolySans',
    textTransform: 'none',
    fontSize: '0.875rem',
    border: `1px solid ${palette.grey.grey400}`,
    color: palette.text.primary,
    backgroundColor: active ? palette.secondary.purple200 : palette.white,

    '&:hover': {
      backgroundColor: palette.white,
      border: `1px solid ${palette.secondary.purple700}`,
      color: palette.secondary.purple700,
    },
  })
)

interface PrimaryButtonProps extends ButtonProps {
  children: React.ReactNode
  isLoading?: boolean
  active?: boolean
}

const PrimaryButton = React.memo((props: PrimaryButtonProps) => {
  const { children, isLoading, active = false, ...rest } = props

  if (isLoading) {
    return (
      <PrimaryButtonContainer {...rest} variant='outlined' color='secondary'>
        <CircularProgress size={20} color='inherit' />
      </PrimaryButtonContainer>
    )
  }

  return (
    <PrimaryButtonContainer
      {...rest}
      variant='outlined'
      color='secondary'
      active={active}
    >
      {children}
    </PrimaryButtonContainer>
  )
})

export default PrimaryButton
